module.exports = __webpack_public_path__ + "static/media/30OIOS3.253c841f.jpg";